import React, { useState } from "react";
import CampaignOutcomesSection from "./components/CampaignOutcomesSection";
import CampaignPerformanceSection from "./components/CampaignPerformanceSection";
import CampaignSendsModal from "./components/CampaignSendsModal";
import DashboardHeader from "./components/DashboardHeader";
import FirebaseAnalyticsSection from "./components/FirebaseAnalyticsSection";
import KpiStrip from "./components/KpiStrip";
import ReportedPostsPanel from "./components/ReportedPostsPanel";
import RunEngagementModal from "./components/RunEngagementModal";
import SegmentChartsSection from "./components/SegmentChartsSection";
import SegmentUsersModal from "./components/SegmentUsersModal";
import styles from "./styles/Dashboard.module.scss";

export default function Dashboard() {
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [runModalOpen, setRunModalOpen] = useState(false);

  return (
    <div className={styles.Dashboard}>
      <DashboardHeader onRunClick={() => setRunModalOpen(true)} />

      <KpiStrip onSegmentSelect={setSelectedSegment} />

      <FirebaseAnalyticsSection />

      <SegmentChartsSection onSegmentSelect={setSelectedSegment} />

      <CampaignPerformanceSection onCampaignSelect={setSelectedCampaign} />

      <CampaignOutcomesSection />

      <div className="w-100 mt-4 mb-4">
        <ReportedPostsPanel />
      </div>

      <SegmentUsersModal
        open={Boolean(selectedSegment)}
        segmentKey={selectedSegment}
        onClose={() => setSelectedSegment(null)}
      />

      <CampaignSendsModal
        open={Boolean(selectedCampaign)}
        campaign={selectedCampaign}
        onClose={() => setSelectedCampaign(null)}
      />

      <RunEngagementModal
        open={runModalOpen}
        onClose={() => setRunModalOpen(false)}
      />
    </div>
  );
}
